import api from "@/services/api";
import type {
	Driver,
	DriverById,
	GetDriversParams,
	ImportDriversResult,
	PaginatedDrivers,
	UpdateDriverPayload,
	Vehicle,
} from "../types";

export const driversService = {
	// Listar todos os motoristas
	async getAllDrivers(params?: GetDriversParams): Promise<PaginatedDrivers> {
		const response = await api.get("/api/driver", { params });
		return response.data;
	},

	// Pegar motorista por ID
	async getDriverById(id: number): Promise<DriverById> {
		const response = await api.get(`/api/driver/${id}`);
		return response.data;
	},

	// Exportar motoristas
	async exportDrivers(): Promise<Driver[]> {
		const response = await api.get("/api/driver/export");
		return response.data;
	},

	// Importar motoristas via arquivo
	async importDrivers(file: File): Promise<ImportDriversResult> {
		const formData = new FormData();
		formData.append("File", file);

		const response = await api.post<ImportDriversResult>(
			"/api/driver/import",
			formData,
			{
				headers: { "Content-Type": "multipart/form-data" },
			}
		);

		return response.data;
	},

	//  pedir presigned URL
	async getPresignedUrl({
		driverId,
		fileName,
		contentType,
	}: {
		driverId: number;
		fileName: string;
		contentType: string;
	}): Promise<{ uploadUrl: string; filePath: string }> {
		const response = await api.post("/api/driver/presigned", {
			driverId,
			fileName,
			contentType,
		});
		return response.data;
	},

	// upload do arquivo para o storage
	async uploadFile(uploadUrl: string, file: File, contentType: string) {
		await api.put(uploadUrl, file, {
			headers: {
				"Content-Type": contentType,
			},
		});
	},

	// Atualizar dados do motorista
	async updateDriver(
		id: number,
		payload: UpdateDriverPayload
	): Promise<Driver> {
		const response = await api.put(`/api/driver/${id}/update`, payload);
		return response.data;
	},

	// Alterar status (ativo/inativo)
	async updateDriverStatus(
		driverId: number,
		isActive: boolean
	): Promise<Driver> {
		const response = await api.put(`/api/driver/${driverId}/status`, {
			isActive,
		});
		return response.data;
	},

	async getDriversWithoutCnh(
		params?: GetDriversParams
	): Promise<PaginatedDrivers> {
		const response = await api.get("/api/driver/card/without-cnh", { params });
		return response.data;
	},

	async getDriversExpired30Days(
		params?: GetDriversParams
	): Promise<PaginatedDrivers> {
		const response = await api.get("/api/driver/card/expired-30days", {
			params,
		});
		return response.data;
	},

	async getDriversExpiredCnh(
		params?: GetDriversParams
	): Promise<PaginatedDrivers> {
		const response = await api.get("/api/driver/card/expired-cnh", { params });
		return response.data;
	},

	async getAllVehicles(): Promise<Vehicle[]> {
		const response = await api.get("/api/vehicle/all");
		return response.data;
	},
};
